import React from 'react';
import { useAccessSharingFlowContext } from 'app/hooks/access-sharing';
import { ACCESS_SHARING_FLEET_STEPS } from 'app/constants/access-sharing';
import { FleetSelectionView } from 'app/components/access-sharing/flows';

interface Props {
  fleets: any[];
  onBack: () => void;
}

export default function FleetSelectionStepController({
  fleets,
  onBack,
}: Props) {
  const {
    stepper,
    isEditing,
    setIsEditing,
    selectedFleetId,
    setSelectedFleetId,
  } = useAccessSharingFlowContext();

  const { setStep } = stepper;

  function handlePrevStep() {
    if (isEditing) {
      setStep(ACCESS_SHARING_FLEET_STEPS.OVERVIEW);
      setIsEditing(false);
    } else {
      onBack();
    }
  }

  function handleCreateFleet() {
    setStep(ACCESS_SHARING_FLEET_STEPS.FLEET_CREATION);
  }

  function handleNextStep() {
    if (isEditing) {
      setStep(ACCESS_SHARING_FLEET_STEPS.OVERVIEW);
      setIsEditing(false);
    } else {
      setStep(ACCESS_SHARING_FLEET_STEPS.ACCESS_SHARING);
    }
  }

  return (
    <FleetSelectionView
      fleets={fleets}
      selectedFleetId={selectedFleetId}
      setSelectedFleetId={setSelectedFleetId}
      onBack={handlePrevStep}
      onCreateFleet={isEditing ? undefined : handleCreateFleet}
      onNextStep={handleNextStep}
    />
  );
}
